<template>
	<div class="BaseLabourHoursGraph">
		<div v-if="isGraphDataAvailable" ref="LaboueHours" style="width: 100%; height: 300px; overflow: hidden;"></div>
		<div v-else>
			<h3 style="text-align: center; padding-top: 50px;">No Data Found</h3>
		</div>
	</div>
</template>
<script>
var echarts = require("echarts");
import { GraphData } from "../../../../mixins/baseReportGraphData.js";
import { EventBus } from "../../../eventBus.js";
import moment from "moment";

export default {
	name: "BaseLabourHoursGraph",
	mixins: [GraphData],
	props: {
		graphDetails: {
			type: Array,
			default: () => []
		},
		graphSingleData: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			daySchdulerGraphInstance: "",
			colors: [" #e29d5a", "#F9CB9C", "#FCE5CD"],
			// colors: ["#4472c4", "#e29d5a", "#c9daf8"],
			// colors: ["#66cc66", "#8000ff", "#ffa31a", "#80d4ff", "#b30000"],
			isGraphDataAvailable: true
		};
	},

	mounted() {

		// this.initBwaseGraph();
		// this.map_graph_data(this.graphDetails, this.graphSingleData);
		this.initBaseGraph();
		EventBus.$on("reponseLabourHoursGraph", data => {
			// this.clearGraph();
			this.map_graph_data(data.data, data.name);
		});
	},

	beforeDestroy() {
		EventBus.$off();
	},

	methods: {
		map_graph_data(graph_data, name) {
			this.graphXaxis[0].data = [];
			this.graphSeries = [];
			this.getNameOfGraph = name;
			this.graphColors = this.colors;

			if(name == "Labour Hours") {

				// if(this.getUserDetails && this.getUserDetails.email != 'admin@wellnessforever.in'){
					let Ideal = {
						name: "Coverage Hrs",
						type: "bar",
						barGap: 0,
						barWidth: 20,
						data: []
					};

					let Scheduled = {
						name: "Non Coverage Hrs ",
						type: "bar",
						barGap: 0,
						barWidth: 20,
						data: []
					// };
				}


				let Actual = {
					name: "Total",
					type: "bar",
					barGap: 0,
					barWidth: 20,
					data: []
					// yAxisIndex: 1
				};

				if (graph_data.length) {
					// this.graphXaxis[0].axisLabel.rotate = 90;
					// this.graphYaxis[0].axisLine = {
					// 	show: false
					// };
					this.graphYaxis = [
						{
							type: "value",
							name: "",
							axisLine: {
								show: false
							},
							axisTick: {
								show: false
							},
							axisLabel: {
								margin: 5,
								fontSize: "10"
								// formatter: function(a) {
								// 	console.log("a", a);
								// 	return a / 1000000 + 'M';
								// }
							}
						},
						{
							type: "value",
							name: "",
							axisLine: {
								show: false
							},
							axisTick: {
								show: false
							},
							axisLabel: {
								formatter: "{value}%",
								margin: 20
							}
						}
					];

					this.graphXaxis[0].axisLine = {
						show: false
					};

					this.graphXaxis[0].axisTick = {
						show: false
					};

					this.graphXaxis[0].axisLabel = {
						// interval: 0,
						// rotate: 50,
						margin: 20,
						formatter: function(d) {
							return d;
						}
					};

					// this.graphLegend.orient = 'vertical';
					// this.graphLegend.right = 20;
					// this.graphLegend.top = 10;
					// this.graphLegend.bottom = 20;
					// this.graphLegend.itemGap = 5;
					// this.graphLegend.margin = 20;
					if (graph_data.length > 1) {
						this.graphXaxis[0].axisLabel = {
							margin: 20,
							fontSize: "12",
							// rotate: 25,
							formatter: function(d) {
								return d;
							}
						};
					}

					for (var i = 0; i < graph_data.length; i++) {
						if (graph_data[i].name) {
							this.graphXaxis[0].data.push(graph_data[i].name.charAt(0).toUpperCase() + graph_data[i].name.slice(1));
						}

						Actual.data.push(graph_data[i].actual ? graph_data[i].actual : 0);

						if(this.getUserDetails && this.getUserDetails.email != 'admin@wellnessforever.in'){
							Ideal.data.push(graph_data[i].ideal ? graph_data[i].ideal : 0);

							Scheduled.data.push(graph_data[i].scheduled ? graph_data[i].scheduled : 0);
						}
					}

					// Ideal.barWidth = 40;
					// Scheduled.barWidth = 40;
					// Actual.barWidth = 40;
					if(this.getUserDetails && this.getUserDetails.email != 'admin@wellnessforever.in'){
						this.graphSeries.push(Ideal);
						this.graphSeries.push(Scheduled);
					}
					this.graphSeries.push(Actual);
				} else {
					this.isGraphDataAvailable = false;
				}
			} else {
				let Ideal = {
					name: "Labour Cost",
					type: "bar",
					barGap: 0,
					data: []
				};

				// let Scheduled = {
				// 	name: "Cost%",
				// 	type: "bar",
				// 	barGap: 0,
				// 	data: []
				// };
				let Percent = {
				name: "Cost%",
				type: "line",
				barGap: 0,
                data: [],
                lineStyle: {
                    type: 'dashed'
                },
				yAxisIndex: 1
			};
				if (graph_data.length) {
					// this.graphXaxis[0].axisLabel.rotate = 90;
					// this.graphYaxis[0].axisLine = {
					// 	show: false
					// };
					this.graphYaxis = [
						{
							type: "value",
							name: "",
							axisLine: {
								show: false
							},
							axisTick: {
								show: false
							},
							axisLabel: {
								margin: 5,
								fontSize: "10"
								// formatter: function(a) {
								// 	console.log("a", a);
								// 	return a / 1000000 + 'M';
								// }
							}
						},
						{
							type: "value",
							name: "",
							axisLine: {
								show: false
							},
							axisTick: {
								show: false
							},
							axisLabel: {
								formatter: "{value}%",
								margin: 20
							}
						}
					];
					this.graphXaxis[0].axisLine = {
						show: false
					};
					this.graphXaxis[0].axisTick = {
						show: false
					};
					this.graphXaxis[0].axisLabel = {
						// interval: 0,
						// rotate: 50,
						margin: 20,
						formatter: function(d) {
							return d;
						}
					};
					// this.graphLegend.orient = 'vertical';
					// this.graphLegend.right = 20;
					// this.graphLegend.top = 10;
					// this.graphLegend.bottom = 20;
					// this.graphLegend.itemGap = 5;
					// this.graphLegend.margin = 20;
					if (graph_data.length > 1) {
						this.graphXaxis[0].axisLabel = {
							margin: 20,
							fontSize: "12",
							// rotate: 25,
							formatter: function(d) {
								return d;
							}
						};
					}
					for (var i = 0; i < graph_data.length; i++) {
						if (graph_data[i].name) {
							this.graphXaxis[0].data.push(
								graph_data[i].name.charAt(0).toUpperCase() +
									graph_data[i].name.slice(1)
							);
						}
						Ideal.data.push(graph_data[i].data);
						// Actual.data.push(graph_data[i].actual);
						Percent.data.push(
							graph_data[i].percent ? graph_data[i].percent : 0
						);
					}
					Ideal.barWidth = 20;
					// Scheduled.barWidth = 40;
					Percent.barWidth = 20;
					this.graphSeries.push(Ideal);
					// this.graphSeries.push(Scheduled);
					this.graphSeries.push(Percent);
				} else {
					this.isGraphDataAvailable = false;
				}
			}

			this.reRenderGraph();
			// console.log("graphData", this.graphData);
		},

		clearGraph: function() {
			this.daySchdulerGraphInstance.clear();
		},

		reRenderGraph: function() {
			this.clearGraph();
			this.daySchdulerGraphInstance.setOption(this.graphData);
			this.daySchdulerGraphInstance.hideLoading();
		},

		initBaseGraph() {
			let baseGraphContainer = this.$refs["LaboueHours"];
			this.daySchdulerGraphInstance = echarts.init(
				baseGraphContainer,
				null,
				this.initOptions
			);
			this.daySchdulerGraphInstance.showLoading();
		}
	},

	computed: {
		getUserDetails() {
			return this.$store.state.loginUserDetails;
		}
	}
};
</script>
<style lang="scss" scoped>
.BaseLabourHoursGraph {
	margin: 0 10px;
}
</style>
